import { get } from 'lodash-es';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['loadingWidgets']),
    isReady() {
      return !get(this.loadingWidgets, this.widgetKey, false);
    },
    bodyClasses() {
      return !this.isReady && this.isFirstLoad ? 'widget-loading' : '';
    },
    isEmptyWidget() {
      return this.widgetData && 'empty_reason' in this.widgetData;
    },
    emptyReason() {
      return this.widgetData?.empty_reason || 'no_data';
    },
  },
  data: () => ({
    isFirstLoad: true,
  }),
};
